import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Rbac from 'src/containers/rbac';
import CONSTANTS from 'src/store/constants';
import { Icon, Text } from '@pinpoint/design-kit';

function UserActions({ id, isActive, openModal }) {
  const history = useHistory();
  return (
    <Rbac
      roles={[CONSTANTS.ROLE.SUPER_ADMIN, CONSTANTS.ROLE.CLIENT_SERVICES_ADMIN, CONSTANTS.ROLE.CLIENT_SERVICES]}
      fallback={
        <Text textSize="small" m={{ r: '.3125rem' }}>
          &ndash;
        </Text>
      }
    >
      <Icon
        name="Edit"
        cursor="pointer"
        hoverTransform="scale(1.25)"
        size=".75rem"
        m={{ r: '.3125rem' }}
        onClick={() => {
          history.push(`/users/${id}`);
        }}
      />
      <Icon
        name={isActive ? 'Cross' : 'Checked'}
        cursor="pointer"
        hoverTransform="scale(1.25)"
        m={{ x: '.3125rem' }}
        size=".75rem"
        onClick={() => openModal(isActive, id)}
        data-tip={isActive ? 'Deactivate' : 'Reactivate'}
      />
    </Rbac>
  );
}

UserActions.propTypes = {
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
};

export default UserActions;
